<template>
    
    <div class="modal-mask" v-on:scroll="scrollPage($el)">
        <div class="modal-wrapper">
            <div class="modal-container" dir="" id="review_container">
                <header class="mdc-top-app-bar mdc-top-app-bar--fixed">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">close</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">{{title}}</div>                
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                    </div>
                </header>

                <section class="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust">
                    <form @submit.prevent="enterAwait()" novalidate>
                    <div class="mdc-layout-grid">
                        <div class="mdc-layout-grid__inner">
                            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
                                <div class="mdc-text-field mdc-text-field--outlined w-full"
                                    :class="submitState && emailInvalidCheck ? 'mdc-text-field--invalid' : ''"
                                    id="emailEl"
                                >
                                    <input type="email" class="mdc-text-field__input"
                                        v-model="email"
                                        v-validate="'required|email'"
                                        ref="email"
                                        id="email"
                                        name="email"
                                        maxlength="100"
                                        
                                    >
                                    <div class="mdc-notched-outline">
                                        <div class="mdc-notched-outline__leading"></div>
                                        <div class="mdc-notched-outline__notch">
                                        <label for="tf-outlined" class="mdc-floating-label">{{$t('Email')}}</label>
                                        </div>
                                        <div class="mdc-notched-outline__trailing"></div>
                                    </div>
                                    
                                </div>
                                <div class="t-helper text-helper warning">
                                    <span v-show="submitState && emailInvalidCheck"  v-html="'* ' + $t('SignUp.00044')"></span>
                                </div>

                                <div class="mdc-text-field mdc-text-field--outlined w-full"
                                    :class="submitState && cellPhoneInvalidCheck ? 'mdc-text-field--invalid' : ''"
                                    id="cellPhoneEl"
                                >
                                    <input type="text" class="mdc-text-field__input"
                                        v-model="cellPhone"
                                        v-validate="'required'"
                                        ref="cellPhone"
                                        id="cellPhone"
                                        name="cellPhone"
                                        maxlength="50"
                                    >
                                    <div class="mdc-notched-outline">
                                        <div class="mdc-notched-outline__leading"></div>
                                        <div class="mdc-notched-outline__notch">
                                        <label for="tf-outlined" class="mdc-floating-label">{{$t('Cell Phone')}}</label>
                                        </div>
                                        <div class="mdc-notched-outline__trailing"></div>
                                    </div>
                                </div>
                                <div class="t-helper text-helper warning">
                                    <span v-show="submitState && cellPhoneInvalidCheck">
                                        {{$t('TODO-공석발생시 연락받을 연락처를 입력해주세요.')}}
                                    </span>
                                </div>
                                <div class="mt26 mb19">
                                    <button class="mdc-button mdc-button--raised btn-red mr8">
                                        {{$t('TODO-대기자 신청')}}
                                        <!-- 다음 -->
                                    </button>
                                    <button class="mdc-button btn-white" @click="cancelEnterAwait()" @keypress="cancelEnterAwait()" type="button" tabindex="0">
                                        {{$t('Common.00002')}}
                                        <!-- 취소 -->
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    </form>
                    

                    
                </section>

    
            </div>
        </div>
    </div>
    
</template>

<script>
/**
 * 대기자 신청 컴포넌트(Waiting application component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'

import {topAppBarMixin} from '@/mixins/topAppBar.js'
export default {
    data() {
        return {
            title: '대기자 신청 정보 수정',
            email: 'koica@emacast.com',
            cellPhone: '01020118284',

            emailTextField: null,
            cellPhoneTextField: null,
            submitState: false
        }
    },
    
    beforeMount () {
        
        
    },
    mounted() {
        this.setMaterialUi()

    },
    updated() {
        
    },

    computed: {
        // 이메일 유효성 체크(Email Validation)
        emailInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('email')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.emailTextField.valid === !returnValue ? '' : this.emailTextField.valid = !returnValue
            return returnValue
        },
        // 연락처 유효성 체크(cellphone Validation)
        cellPhoneInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('cellPhone')) {
                    returnValue = true
                }else {
                    returnValue = false
                }
            }
            this.cellPhoneTextField.valid === !returnValue ? '' : this.cellPhoneTextField.valid = !returnValue
            return returnValue
        },
    },

    methods: {
        setMaterialUi() {
            this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
            this.emailTextField.useNativeValidation = false

            this.cellPhoneTextField = new MDCTextField(document.querySelector('#cellPhoneEl'))
            this.cellPhoneTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        cancelEnterAwait() {
            this.$router.go(-1)
        },

        // 대기자 신청(Waiting application)
        enterAwait() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.$router.go(-1)
                }
            })
            
        }
        
    }
}
</script>